import { faDownload, faLink } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Image, Modal } from '@tryhackme/thm-ui-components';
import { useEffect, useState } from 'react';
import { useCopyToClipboard } from 'src/common/hooks/use-copy-to-clipboard';
import { useGenerateStreakImageQuery } from 'src/features/streak/streak.slice';
import { StreakSocialSharing } from './components/streak-social-share';
import { StyledActionButton, StyledActionButtonsWrapper, StyledButtonsWrapper, StyledWrapperContent } from './streak-share-modal.styles';
import type { ShareRoomsCompletionModalProps } from './streak-share-modal.types';
export const StreakShareModal = ({
  streakLength,
  onOpenChange,
  isShareModalOpen,
  setIsShareModalOpen,
  isCompletionShareRoomModal,
  username = '',
  ...otherModalProps
}: ShareRoomsCompletionModalProps) => {
  const [streakImageUrl, setStreakImageUrl] = useState<string>(`https://tryhackme-images.s3.amazonaws.com/streak/${username}.png`);
  const {
    data: streakImage
  } = useGenerateStreakImageQuery(void 0, {
    skip: !isShareModalOpen
  });
  const {
    copyToClipboard
  } = useCopyToClipboard({
    addSharerId: true,
    eventProperties: {
      componentName: StreakShareModal.name
    }
  });
  const streakUrl = `https://tryhackme.com/${username}/streak`;
  const handleDownloadImage = () => {
    window.open(streakImageUrl, '_blank');
  };
  useEffect(() => {
    if (streakImage && streakImage?.data?.imageUrl) setStreakImageUrl(streakImage?.data?.imageUrl);
  }, [streakImage]);
  return <Modal {...otherModalProps} onOpenChange={onOpenChange} open={isShareModalOpen} data-sentry-element="Modal" data-sentry-component="StreakShareModal" data-sentry-source-file="streak-share-modal.tsx">
      <StyledWrapperContent data-sentry-element="StyledWrapperContent" data-sentry-source-file="streak-share-modal.tsx">
        <Image src={streakImageUrl} alt="Streak Image" width="100%" data-sentry-element="Image" data-sentry-source-file="streak-share-modal.tsx" />

        <p>Stand out in the Cybersecurity community! Share your current streak with your friends and community!</p>

        <StyledButtonsWrapper data-sentry-element="StyledButtonsWrapper" data-sentry-source-file="streak-share-modal.tsx">
          <StreakSocialSharing streakUrl={streakUrl} data-sentry-element="StreakSocialSharing" data-sentry-source-file="streak-share-modal.tsx" />

          <StyledActionButtonsWrapper data-sentry-element="StyledActionButtonsWrapper" data-sentry-source-file="streak-share-modal.tsx">
            <StyledActionButton variant="outlined" color="secondary" onClick={handleDownloadImage} data-sentry-element="StyledActionButton" data-sentry-source-file="streak-share-modal.tsx">
              <FontAwesomeIcon icon={faDownload} data-sentry-element="FontAwesomeIcon" data-sentry-source-file="streak-share-modal.tsx" />
              Download image
            </StyledActionButton>
            <StyledActionButton variant="outlined" color="secondary" onClick={() => copyToClipboard(streakUrl)} data-sentry-element="StyledActionButton" data-sentry-source-file="streak-share-modal.tsx">
              <FontAwesomeIcon icon={faLink} data-sentry-element="FontAwesomeIcon" data-sentry-source-file="streak-share-modal.tsx" />
              Copy link
            </StyledActionButton>
          </StyledActionButtonsWrapper>
        </StyledButtonsWrapper>
      </StyledWrapperContent>
    </Modal>;
};